export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    /** @deprecated */
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
    NodeType["CAPTION"] = "CAPTION";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var ButtonDataType;
(function (ButtonDataType) {
    /** Regular link button */
    ButtonDataType["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    ButtonDataType["ACTION"] = "ACTION";
})(ButtonDataType || (ButtonDataType = {}));
export var Target;
(function (Target) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    Target["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    Target["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    Target["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    Target["TOP"] = "TOP";
})(Target || (Target = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source || (Source = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var CommentStatusStatus;
(function (CommentStatusStatus) {
    /** Unknown status. */
    CommentStatusStatus["UNKNOWN"] = "UNKNOWN";
    /** This comment is published and publicly visible. */
    CommentStatusStatus["PUBLISHED"] = "PUBLISHED";
    /** This comment is deleted. */
    CommentStatusStatus["DELETED"] = "DELETED";
    /** This comment is pending moderation. Moderation is not currently supported. */
    CommentStatusStatus["PENDING"] = "PENDING";
    /** This comment has been hidden by a site moderator. */
    CommentStatusStatus["HIDDEN"] = "HIDDEN";
})(CommentStatusStatus || (CommentStatusStatus = {}));
/** Type of vote */
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["UPVOTE"] = "UPVOTE";
    Type["DOWNVOTE"] = "DOWNVOTE";
})(Type || (Type = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["ANONYMOUS"] = "ANONYMOUS";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["USER"] = "USER";
    IdentityType["SERVICE"] = "SERVICE";
    /** indicates everyone who is a member of a group */
    IdentityType["MEMBER_GROUP"] = "MEMBER_GROUP";
})(IdentityType || (IdentityType = {}));
export var ReasonTypeType;
(function (ReasonTypeType) {
    /** Unknown type. This value is not used. */
    ReasonTypeType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** Entity is reported for other reasons. Specify in `details`. */
    ReasonTypeType["OTHER"] = "OTHER";
    /** Entity is reported for spam. */
    ReasonTypeType["SPAM"] = "SPAM";
    /** Entity is reported for nudity or sexual harassment. */
    ReasonTypeType["NUDITY_OR_SEXUAL_HARASSMENT"] = "NUDITY_OR_SEXUAL_HARASSMENT";
    /** Entity is reported for hate speech. */
    ReasonTypeType["HATE_SPEECH_OR_SYMBOLS"] = "HATE_SPEECH_OR_SYMBOLS";
    /** Entity is reported for false information. */
    ReasonTypeType["FALSE_INFORMATION"] = "FALSE_INFORMATION";
    /** Entity is reported for a community guideline violation. */
    ReasonTypeType["COMMUNITY_GUIDELINES_VIOLATION"] = "COMMUNITY_GUIDELINES_VIOLATION";
    /** Entity is reported for violence. */
    ReasonTypeType["VIOLENCE"] = "VIOLENCE";
    /** Entity is reported for mentioning suicide. */
    ReasonTypeType["SUICIDE_OR_SELF_INJURY"] = "SUICIDE_OR_SELF_INJURY";
    /** Entity is reported for unuathorized sales. */
    ReasonTypeType["UNAUTHORIZED_SALES"] = "UNAUTHORIZED_SALES";
    /** Entity is reported for mentioning an eating disorder. */
    ReasonTypeType["EATING_DISORDER"] = "EATING_DISORDER";
    /** Entity is reported for involving a minor. */
    ReasonTypeType["INVOLVES_A_CHILD"] = "INVOLVES_A_CHILD";
    /** Entity is reported for mentioning terrorism. */
    ReasonTypeType["TERRORISM"] = "TERRORISM";
    /** Entity is reported for mentioning drugs. */
    ReasonTypeType["DRUGS"] = "DRUGS";
    /** Entity is reported for unlawful actions. */
    ReasonTypeType["UNLAWFUL"] = "UNLAWFUL";
    /** Entity is reported for exposing identifying details. */
    ReasonTypeType["EXPOSING_IDENTIFYING_INFO"] = "EXPOSING_IDENTIFYING_INFO";
})(ReasonTypeType || (ReasonTypeType = {}));
export var Fieldset;
(function (Fieldset) {
    Fieldset["UNKNOWN_FIELDSET"] = "UNKNOWN_FIELDSET";
    Fieldset["MEMBERS"] = "MEMBERS";
    Fieldset["CURRENT_MEMBER"] = "CURRENT_MEMBER";
    Fieldset["REACTIONS"] = "REACTIONS";
    Fieldset["REGISTRATION_DATA"] = "REGISTRATION_DATA";
    Fieldset["MEMBER_ROLES"] = "MEMBER_ROLES";
    Fieldset["MEMBER_BADGES"] = "MEMBER_BADGES";
    Fieldset["TOTAL_COMMENTS"] = "TOTAL_COMMENTS";
    Fieldset["FOLLOWED_MEMBERS"] = "FOLLOWED_MEMBERS";
    Fieldset["VOTES"] = "VOTES";
    Fieldset["CURRENT_RATING"] = "CURRENT_RATING";
    Fieldset["RATINGS_SUMMARY"] = "RATINGS_SUMMARY";
    Fieldset["BLOCKED_MEMBERS"] = "BLOCKED_MEMBERS";
    Fieldset["CONTEXT_PERMISSIONS"] = "CONTEXT_PERMISSIONS";
})(Fieldset || (Fieldset = {}));
export var Status;
(function (Status) {
    /** Insufficient permissions to get the status. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** Member created and is waiting for approval by site owner. */
    Status["PENDING"] = "PENDING";
    /** Member can log in to the site. */
    Status["APPROVED"] = "APPROVED";
    /** Member is blocked and can't log in to the site. */
    Status["BLOCKED"] = "BLOCKED";
    /** Member is a [guest author](https://support.wix.com/en/article/wix-blog-adding-guest-authors-to-your-blog) for the site blog and can't log in to the site. */
    Status["OFFLINE"] = "OFFLINE";
})(Status || (Status = {}));
export var PrivacyStatusStatus;
(function (PrivacyStatusStatus) {
    /** Insufficient permissions to get the status. */
    PrivacyStatusStatus["UNKNOWN"] = "UNKNOWN";
    /** Member is hidden from site visitors and other site members. Member is returned only to site contributors and apps with the appropriate permissions. */
    PrivacyStatusStatus["PRIVATE"] = "PRIVATE";
    /** Member is visible to everyone. */
    PrivacyStatusStatus["PUBLIC"] = "PUBLIC";
})(PrivacyStatusStatus || (PrivacyStatusStatus = {}));
export var ActivityStatusStatus;
(function (ActivityStatusStatus) {
    /** Insufficient permissions to get the status. */
    ActivityStatusStatus["UNKNOWN"] = "UNKNOWN";
    /** Member can write forum posts and blog comments. */
    ActivityStatusStatus["ACTIVE"] = "ACTIVE";
    /** Member can't write forum posts or blog comments. */
    ActivityStatusStatus["MUTED"] = "MUTED";
})(ActivityStatusStatus || (ActivityStatusStatus = {}));
export var Role;
(function (Role) {
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    Role["FORUM_MODERATOR"] = "FORUM_MODERATOR";
    Role["BLOG_WRITER"] = "BLOG_WRITER";
    Role["BLOG_EDITOR"] = "BLOG_EDITOR";
    /** Deprecated, use member status */
    Role["BLOCKED"] = "BLOCKED";
    Role["OWNER"] = "OWNER";
    Role["CONTRIBUTOR"] = "CONTRIBUTOR";
})(Role || (Role = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Order;
(function (Order) {
    /** Unknown order. */
    Order["UNKNOWN_ORDER"] = "UNKNOWN_ORDER";
    /** Oldest comments appear at the top of the list. */
    Order["OLDEST_FIRST"] = "OLDEST_FIRST";
    /** Newest comments appear at the top of the list. */
    Order["NEWEST_FIRST"] = "NEWEST_FIRST";
    /** Comments with the highest reaction count appear at the top of the list. */
    Order["REACTION_COUNT"] = "REACTION_COUNT";
    /** Comments with the highest vote count appear at the top of the list. */
    Order["NET_VOTE_COUNT"] = "NET_VOTE_COUNT";
    /** Comments with the highest rating appear at the top of the list. */
    Order["RATING"] = "RATING";
    /** Comments with the lowest vote count appear at the top of the list. */
    Order["NET_VOTE_COUNT_ASC"] = "NET_VOTE_COUNT_ASC";
    /** Comments with the lowest rating appear at the top of the list. */
    Order["RATING_ASC"] = "RATING_ASC";
})(Order || (Order = {}));
export var ReplySortOrder;
(function (ReplySortOrder) {
    /** Unknown order. */
    ReplySortOrder["UNKNOWN_ORDER"] = "UNKNOWN_ORDER";
    /** Oldest comments appear at the top of the list. */
    ReplySortOrder["OLDEST_FIRST"] = "OLDEST_FIRST";
    /** Newest comments appear at the top of the list. */
    ReplySortOrder["NEWEST_FIRST"] = "NEWEST_FIRST";
    /** Comments with the highest reaction count appear at the top of the list. */
    ReplySortOrder["REACTION_COUNT"] = "REACTION_COUNT";
})(ReplySortOrder || (ReplySortOrder = {}));
//# sourceMappingURL=types.impl.js.map